import React from 'react';
import PropTypes from 'prop-types';

import './logo.css';

const classNames = ({
  className, spin, white, small, medium, big,
}) => {
  const names = ['Logo'];
  if (className) {
    names.push(className);
  }
  if (spin) {
    names.push('spin');
  }
  if (white) {
    names.push('white');
  }
  if (small) {
    names.push('small');
  }
  if (medium) {
    names.push('medium');
  }
  if (big) {
    names.push('big');
  }
  return names.join(' ');
};

const Logo = ({
  className,
  spin,
  white,
  small,
  medium,
  big,
}) => (
  <div
    className={classNames({
      className,
      spin,
      white,
      small,
      medium,
      big,
    })}
  >
    <svg
      version="1.1"
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="0 0 160 88"
      enableBackground="new 0 0 160 88"
      xmlSpace="preserve"
    >
      <g>
        <polygon className="brick-1" points="46.4,45.1 16.1,75.4 16.1,45.1" />
        <polygon className="brick-2" points="48.6,45.1 78.9,75.4 78.9,45.1" />
        <polygon className="brick-3" points="111.4,45.1 81.1,75.4 81.1,45.1 " />
        <polygon className="brick-4" points="113.6,45.1 143.9,75.4 143.9,45.1" />
        <polygon className="brick-5" points="46.4,12.6 16.1,42.9 46.4,42.9" />
        <polygon className="brick-6" points="111.4,12.6 81.1,42.9 111.4,42.9" />
        <polygon className="brick-7" points="48.6,12.6 78.9,42.9 48.6,42.9" />
        <polygon className="brick-8" points="113.6,12.6 143.9,42.9 113.6,42.9" />
      </g>
    </svg>
  </div>
);

Logo.propTypes = {
  className: PropTypes.string,
  spin: PropTypes.bool,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  big: PropTypes.bool,
  white: PropTypes.bool,
};

Logo.defaultProps = {
  className: '',
  spin: false,
  small: false,
  medium: false,
  big: false,
  white: false,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/assets/logos/logo.jsx